<app-chips-autocomplete
        [parentFormGroup]="parentFormGroup"
        [parentFormControlName]="parentFormControlName"
        [elements]="lovValueElements"
        [loading]="lovValueSummaryFindAllService.loading$ | async"
        [loadingError]="lovValueSummaryFindAllService.error$ | async">
</app-chips-autocomplete>
